import React from 'react'
import { connect } from 'react-redux'
import Loading from './widgets/Loading'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import {
  PRODUCT_ADD_PAGE_LOADED,
  PRODUCT_ADD_PAGE_UNLOADED,
  PRODUCT_ADD,
  REDIRECT
} from '../constants/actionTypes'
import Header from './widgets/Header'
import CrumbBox from './widgets/CrumbBox'
import { BASE_COIN_SYMBOL } from '../constants/config'
import ListErrors from './ListErrors'
const Promise = global.Promise

const mapStateToProps = state => ({
  ...state.settings,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress,
  baseAccount: state.common.baseAccount,
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) =>
    dispatch({ type: PRODUCT_ADD_PAGE_LOADED, payload }),
  onSubmit: (payload) => {
    dispatch({ type: PRODUCT_ADD, payload })
  },
  onUnload: () =>
    dispatch({ type: PRODUCT_ADD_PAGE_UNLOADED }),
  onRedirect: () =>
    dispatch({ type: REDIRECT })
})

class ProductAdd extends React.Component {
  constructor() {
    super();
    this.state = {
      name: '',
      price: '',
      currency: BASE_COIN_SYMBOL,
      category: '',
      categories: []
    }
    this.onSelectCategory = this.onSelectCategory.bind(this)
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.submitForm = (name, price, currency, category) => ev => {
      ev.preventDefault();
      const payload = agent.Products.addProduct(name, price, currency, category)
      this.props.onSubmit(payload);
    }
  }
  onSelectCategory(option) {
    this.setState({ category: option.value })
  }
  componentWillMount() {
    if (this.props.currentUser) {
      this.setState({ currency: this.props.currentUser.currency_code })

      const payload = agent.Categories.getCategories(this.props.currentUser.key)
      this.props.onLoad(payload);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.updated === true) {
      store.dispatch(push('/products/manage'))
      this.props.onRedirect()
    } else if (nextProps.categories) {
      let categories = []
      for (let i in nextProps.categories) {
        let name = nextProps.categories[i].name
        categories.push({ label: name, value: name })
      }
      this.setState({ categories: categories })
    }
  }
  componentWillUnmount() {
    this.props.onUnload();
  }

  render() {
    if (!this.props.categories) {
      return (
        <Loading />
      )
    }
    const name = this.state.name;
    const price = this.state.price;
    const currency = this.state.currency
    const category = this.state.category
    const categories = this.state.categories
    return (
      <div>
        <Header />
        <CrumbBox data={[{ key: 'Add Product' }]} rootKey='/settings' rootVal='Settings' />
        <div id="focus">
          <div id="main">
            <div id="main-wrap">
              <div id="focus-wrap">
                <h2>Add Product</h2>
                <div className="FormItem">
                  <label>Name</label>
                  <input type="text" placeholder="Product Name" value={name} onChange={this.updateState('name')} />
                </div>
                <div className="FormItem">
                  <label>Category</label>
                  <div style={{ maxWidth: '500px', 'text-align': 'left' }}><Dropdown options={categories} onChange={this.onSelectCategory} value={category} /></div>
                </div>
                <div className="FormItem">
                  <label>Price</label>
                  <input
                    type="text"
                    placeholder="Price"
                    value={price}
                    onChange={this.updateState('price')} />
                </div>
                <div className="FormItem">
                  <label>Currency</label>
                  <span className="ReferenceInput">{currency}</span>
                </div>
                <ListErrors errors={this.props.errors} />
                <div className="FormItem">
                  <button type="button"
                    onClick={this.submitForm(name, price, currency, category)}
                    disabled={this.props.inProgress}>
                    Create Product
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductAdd)
